var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    enableBackground: "new -255 347 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.569,0,30,13.431,30,30s-13.431,30-30,30s-30-13.431-30-30S-221.569,367-205,367 M-205,362   c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S-185.701,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.585,415.002h-30.83c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h30.83c1.381,0,2.5,1.119,2.5,2.5   S-188.204,415.002-189.585,415.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-191.802,385.999c3.038,0,5.5,2.462,5.5,5.5c0,3.038-2.462,5.5-5.5,5.5s-5.5-2.462-5.5-5.5   C-197.302,388.462-194.84,385.999-191.802,385.999 M-191.802,380.999c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5   s10.5-4.71,10.5-10.5S-186.012,380.999-191.802,380.999L-191.802,380.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-218.198,385.999c3.038,0,5.5,2.462,5.5,5.5c0,3.038-2.462,5.5-5.5,5.5s-5.5-2.462-5.5-5.5   C-223.698,388.462-221.235,385.999-218.198,385.999 M-218.198,380.999c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5   s10.5-4.71,10.5-10.5S-212.408,380.999-218.198,380.999L-218.198,380.999z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -218.198,
    cy: 391.499,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -191.802,
    cy: 391.499,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFear);
export default __webpack_public_path__ + "static/media/fear.ba04b8d6ebaf5070043636dc643a2a4d.svg";
export { ForwardRef as ReactComponent };